import { Component } from '@angular/core';

// Added the declaration of BlankComponent to be used for routing
@Component({ selector: 'app-blank', template: `` })
export class BlankComponent {}
